// SEMDetailedNCReport.js
import React, { useState } from "react";
import { Modal, Button, Row, Col, Form, Card } from "react-bootstrap";
import SuperCorrectiveActionReport from './SuperCorrectiveActionReport'
export default function SEMDetailedNCReport({ show, handleClose }) {
    const [superCorrectiveActionReport,setSuperCorrectiveActionReport]=useState(false)
    const [formData] = useState({
        quantityInspected: 50,
        unit: "pcs",
        quantityOnHold: 50,
        quantityPassed: 50,
        ncReason:
            "Lorem ipsum dolor sit amet consectetur. Massa nunc sit auctor semper eget nisl felis. Sed sit euismod ut vitae condimentum ultrices. A pharetra sagittis consequat nunc nam tellus. Faucibus facilisi sem cursus sit netus.",
        caProposed:
            "Lorem ipsum dolor sit amet consectetur. Massa nunc sit auctor semper eget nisl felis. Sed sit euismod ut vitae condimentum ultrices. A pharetra sagittis consequat nunc nam tellus. Faucibus facilisi sem cursus sit netus.",
        caToBeImplemented: "2025-01-01",
    });
    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Body>
                    <Card className="border-0 shadow-sm p-4 font_family">
                        <h4 className="fw-bold mb-3">Detailed NC Report</h4>
                        <Row className="p-3 bg-light rounded mb-3">
                            <Col md={6}>
                                <p className="mb-1">
                                    <strong>Product Name:</strong> MEP
                                </p>
                                <p className="mb-1">
                                    <strong>Qty NC:</strong> 50pcs
                                </p>
                                <p className="mb-0">
                                    <strong>Reported by:</strong> Suresh D (ID12)
                                </p>
                            </Col>
                            <Col md={6}>
                                <p className="mb-1">
                                    <strong>Product ID:</strong> Ru_90_46
                                </p>
                                <p className="mb-1">
                                    <strong>Report Date:</strong> 12/03/2025
                                </p>
                                <p className="mb-0">
                                    <strong>NC Type:</strong> Blowhole
                                </p>
                            </Col>
                            <div className="mt-3">
                                <Button variant="outline-dark" size="sm">
                                    Review NC Report
                                </Button>
                            </div>
                        </Row>
                        <Form>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Quantity Inspected</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={formData.quantityInspected}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Unit</Form.Label>
                                        <Form.Control type="text" value={formData.unit} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Quantity on Hold</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={formData.quantityOnHold}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Quantity Passed</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={formData.quantityPassed}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="mb-3">
                                <Row>

                                </Row>
                                <Form.Label>NC Reason</Form.Label>
                                <Form.Control as="textarea" rows={3} value={formData.ncReason} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>CA Proposed</Form.Label>
                                <Form.Control as="textarea" rows={3} value={formData.caProposed} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-4">
                                <Form.Label>CA to be Implemented by</Form.Label>
                                <Form.Control type="date" value={formData.caToBeImplemented} readOnly />
                            </Form.Group>
                            <div className="d-flex justify-content-end gap-2">
                                <Button className="btn btn-secondary">Mark as Resolved</Button>
                                <Button className="btn btn-secondary" onClick={() => setSuperCorrectiveActionReport(true)}>Corrective Measure Report</Button>
                                <Button className="btn btn-secondary">Validate</Button>
                            </div>
                        </Form>
                    </Card>
                </Modal.Body>

            </Modal>
            <SuperCorrectiveActionReport
                show={superCorrectiveActionReport}
                handleClose={() => setSuperCorrectiveActionReport(false)}
            />
        </>
    );
}
